import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupLevelOfExperienceFilter } from './useSignupLevelOfExperienceFilter';

export const SignupLevelOfExperienceFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, levelOfExperienceOptions } = useSignupLevelOfExperienceFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ signupSeniorities: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupSeniorities"
          label="Level of experience"
          placeholder="Add..."
          size="small"
          component={FormMultiSelect}
          options={levelOfExperienceOptions}
          anchorToBody
          isSearchable={false}
        />
      </Form>
    </Formik>
  );
};

SignupLevelOfExperienceFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SignupLevelOfExperienceFilter.defaultProps = {
  value: [],
};
